import React from "react";
import {
  StyledOuterSliders,
  StyledSliders,
  StyledTab,
  StyledTabIndicator,
  StyledTabs,
} from "./styles";

export const Sliders = ({ focusedIdx, children, duration = 300 }) => {
  const offset = -100 * focusedIdx;

  return (
    <StyledOuterSliders>
      <StyledSliders offset={offset} duration={duration}>
        {children}
      </StyledSliders>
    </StyledOuterSliders>
  );
};

export const Tabs = ({ focusedIdx, children, onChange, duration = 300 }) => {
	return (
		<StyledTabs>
			{React.Children.map(children, (child, i) =>
				React.cloneElement(child, {
					key: i,
					isFocused: focusedIdx === i,
					onClick: e => {
						onChange(i)
					},
				})
			)}
			<StyledTabIndicator
				duration={duration}
				tabCount={children.length}
				offset={`${100 * focusedIdx}%`}
			/>
		</StyledTabs>
	)
}
export const Tab = ({ title, onClick, isFocused }: any) => {
	return (
		<StyledTab onClick={onClick} isFocused={isFocused}>
			<button>{title}</button>
		</StyledTab>
	)
}
